import {
  AccessControlConfig,
  IMultiBuyerPermissions,
} from '../interfaces/multi-buyer-company.interface';

export class MultiBuyerPermissions implements IMultiBuyerPermissions {
  constructor(private readonly _config: AccessControlConfig) {}

  public canSeeMarginAndBank(): boolean {
    return this._config.capabilities.canSeeMarginAndBank;
  }

  public canCreateTemplate(): boolean {
    return this._config.capabilities.canCreateTemplate;
  }

  public canManageBuyerSettings(): boolean {
    return this._config.capabilities.canManageBuyerSettings;
  }

  public canManageSupplierSettings(): boolean {
    return this._config.capabilities.canManageSupplierSettings;
  }

  public hasAccessToTemplate(): boolean {
    return this._config.capabilities.hasAccessToTemplate;
  }

  public canSeeCustomTemplates(): boolean {
    return this._config.capabilities.canSeeCustomTemplates;
  }

  public canSeeSupplierBlends(): boolean {
    return this._config.capabilities.canSeeSupplierBlends;
  }
}
